/*
 * Module for handling of ajax navigation links
 */
rs.module("content/system/configuration/interest/edit",

    ["controls/components/event-banner"],

    function (eventBanner) {

        var _executeSelectionChanged;

        // initialize the module
        function initialize(jsSelectors, codeValues, columnIds, grid, ajaxUrl) {

            // This page either has two edit forms (paramsForm and ratesForm) or one addForm containing the same content
            var addForm = $.js(jsSelectors.addForm, { required: false });
            var paramsForm = $.js(jsSelectors.interestParamForm, { required: false });
            var ratesForm = $.js(jsSelectors.interestRatesForm, { required: false });

            var interestTypeSelector = paramsForm.length > 0 ? paramsForm.js(jsSelectors.interestTypeSelector) : addForm.js(jsSelectors.interestTypeSelector);
            var priorInterestCheckbox = paramsForm.length > 0 ? paramsForm.js(jsSelectors.priorInterestCheckbox) : addForm.js(jsSelectors.priorInterestCheckbox);

            var interestRate = ratesForm.length > 0 ? ratesForm.js(jsSelectors.interestRate) : addForm.js(jsSelectors.interestRate);
            var effectiveDate = ratesForm.length > 0 ? ratesForm.js(jsSelectors.effectiveDate) : addForm.js(jsSelectors.effectiveDate);
            var terminationDate = ratesForm.length > 0 ? ratesForm.js(jsSelectors.terminationDate) : addForm.js(jsSelectors.terminationDate);
            var rateUpdateToken = ratesForm.length > 0 ? ratesForm.js(jsSelectors.rateUpdateToken) : addForm.js(jsSelectors.rateUpdateToken);
            var interestRateKey = ratesForm.js(jsSelectors.interestRateKey, { required: false });

            // these two controls only exist in edit mode
            var addRateLink = ratesForm.js(jsSelectors.addRateLink, { required: false });
            var cancelRateButton = ratesForm.js(jsSelectors.cancelRateButton, { required: false });

            interestTypeSelector.change(interestTypeChanged);

            // disable the percent and amount controls if mode is primary
            function interestTypeChanged() {
                priorInterestCheckbox.prop('disabled', !(this.value == codeValues._401kCode || this.value == codeValues.contributionCode || this.value == codeValues.spcCode));
                if (!(this.value == codeValues._401kCode || this.value == codeValues.contributionCode || this.value == codeValues.spcCode)) {
                    priorInterestCheckbox.setChecked(false);
                }
            }

            if (grid) {
                addRateLink.on("click", addRateClicked);
                cancelRateButton.on("click", cancelRateClicked);

                grid.selectionChanged(function (values, rows) {
                    if (_executeSelectionChanged && values.length > 0) {
                        eventBanner.removeAllMessages();

                        $.get(
                            ajaxUrl,
                            { interestRateKey: rows[0][columnIds.interestRateKey] },

                            function (data) {
                                interestRate.val(data.interestRate).clearErrors();
                                effectiveDate.val(data.effectiveDate ? new Date(data.effectiveDate).toISODateString() : null).clearErrors();
                                terminationDate.val(data.terminationDate ? new Date(data.terminationDate).toISODateString() : null).clearErrors();
                                rateUpdateToken.val(data.updateToken);
                                interestRateKey.val(rows[0][columnIds.interestRateKey])
                            }
                        );
                    }

                    _executeSelectionChanged = true;
                });

                // clear errors, current values, and grid selection when the add rate button is clicked
                function addRateClicked() {
                    eventBanner.removeAllMessages();

                    interestRate.val("").clearErrors();
                    effectiveDate.val("").clearErrors();
                    terminationDate.val("").clearErrors();
                    interestRateKey.val(-1);
                    grid.selectedValues = null;
                }

                // clear errors and reset grid selection to first row
                function cancelRateClicked() {
                    eventBanner.removeAllMessages();

                    grid.selectedValues = null;
                    grid.selectFirstRow();
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);